// @flow
import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
} from 'antd';
import {
  SpH5,
  SpText,
} from 'components/DesignKit';
import NumberFormat from 'react-number-format';

type Props = {
  contactDetailsData: Object,
  fundingSourceDetailsData: Object,
};

const Review = (props: Props) => {
  const {
    contactDetailsData, fundingSourceDetailsData,
  } = props;
  const countryCode = contactDetailsData && contactDetailsData.phoneNumberCode;

  const [phoneFormate, setPhoneFormate] = useState('');

  useEffect(() => {
    if (countryCode === '+1') {
      setPhoneFormate('+# (###) ###-####');
    } else if (countryCode.length !== 4 && countryCode === '+91') {
      setPhoneFormate('+##-##### #####');
    } else if (countryCode.length === 2 && countryCode !== '+1') {
      setPhoneFormate('+#-##########');
    } else if (countryCode.length === 3 && countryCode !== '+91') {
      setPhoneFormate('+##-##########');
    } else if (countryCode.length === 4) {
      setPhoneFormate('+###-##########');
    }
  }, [contactDetailsData]);

  return (
    <>
      <div className="mb-3">
        <Row justify="start">
          <Col>
            <SpH5>CONTACT DETAILS</SpH5>
          </Col>
        </Row>
      </div>
      <div className="mb-3">
        <Row justify="start">
          <Col span={12}>
            <SpH5>Name</SpH5>
          </Col>
          <Col span={12}>
            <SpText>{contactDetailsData.contactName || <>&#8211;</>}</SpText>
          </Col>
        </Row>
      </div>
      <div className="mb-3">
        <Row justify="start">
          <Col span={12}>
            <SpH5>Nick Name</SpH5>
          </Col>
          <Col span={12}>
            <SpText>{contactDetailsData.nickName || <>&#8211;</>}</SpText>
          </Col>
        </Row>
      </div>
      <div className="mb-3">
        <Row justify="start">
          <Col span={12}>
            <SpH5>Phone</SpH5>
          </Col>
          <Col span={12}>
            <NumberFormat
              className="numFormate"
              value={`${contactDetailsData.phoneNumberCode}${contactDetailsData.contactPhone}`}
              format={phoneFormate}
              mask="_"
              disabled
              style={{
                fontWeight: '400',
              }}
            />
          </Col>
        </Row>
      </div>
      <div className="mb-3">
        <Row justify="start">
          <Col span={12}>
            <SpH5>Email</SpH5>
          </Col>
          <Col span={12}>
            <SpText>{contactDetailsData.email || <>&#8211;</>}</SpText>
          </Col>
        </Row>
      </div>
      <div className="mb-3">
        <Row justify="start">
          <Col span={12}>
            <SpH5>Address Line</SpH5>
          </Col>
          <Col span={12}>
            <SpText>{contactDetailsData.streetName || <>&#8211;</>}</SpText>
          </Col>
        </Row>
      </div>
      <div className="mb-3">
        <Row justify="start">
          <Col span={12}>
            <SpH5>City</SpH5>
          </Col>
          <Col span={12}>
            <SpText>{contactDetailsData.cityName || <>&#8211;</>}</SpText>
          </Col>
        </Row>
      </div>
      <div className="mb-3">
        <Row justify="start">
          <Col span={12}>
            <SpH5>postal Code</SpH5>
          </Col>
          <Col span={12}>
            <SpText>{contactDetailsData.zipCode || <>&#8211;</>}</SpText>
          </Col>
        </Row>
      </div>
      <div className="mb-3">
        <Row justify="start">
          <Col span={12}>
            <SpH5>State</SpH5>
          </Col>
          <Col span={12}>
            <SpText>{contactDetailsData.stateName || <>&#8211;</>}</SpText>
          </Col>
        </Row>
      </div>
      <div className="mb-3">
        <Row justify="start">
          <Col span={12}>
            <SpH5>Country</SpH5>
          </Col>
          <Col span={12}>
            <SpText>{contactDetailsData.countryCode || <>&#8211;</>}</SpText>
          </Col>
        </Row>
      </div>
      <div>
        <Row justify="start">
          <Col span={12}>
            <SpH5>Customer Type</SpH5>
          </Col>
          <Col span={12}>
            <SpText>{contactDetailsData.customerType || <>&#8211;</>}</SpText>
          </Col>
        </Row>
      </div>
      {contactDetailsData?.countryCode === 'IN' && (
        <>
          <div className="mb-3 mt-3">
            <Row justify="start">
              <Col span={12}>
                <SpH5>Account Holder Name</SpH5>
              </Col>
              <Col span={12}>
                <SpText>{fundingSourceDetailsData.accountHolderName || <>&#8211;</>}</SpText>
              </Col>
            </Row>
          </div>
          <div>
            <Row justify="start">
              <Col span={12}>
                <SpH5>Account Type</SpH5>
              </Col>
              <Col span={12}>
                <SpText>{fundingSourceDetailsData.accountType || <>&#8211;</>}</SpText>
              </Col>
            </Row>
          </div>
        </>
      )}
    </>
  );
};

// $FlowFixMe
export default Review;
